import { mapState, mapActions } from 'vuex'
import DOMAIN_GET_DETAILS from '@/graphql/DOMAIN_GET_DETAILS.gql'
import MODIFY_DOMAIN_CONTACT from '@/graphql/MODIFY_DOMAIN_CONTACT.gql'
// import GET_ASSIGNABLE_ACCOUNTS from '@/graphql/GET_ASSIGNABLE_ACCOUNTS.gql'

const domainOverviewMixin = {
  computed: {
    ...mapState(['services'])
  },
  data () {
    return {
      domainData: {
        domainName: '',
        autoRenew: '',
        isHidden: false,
        status: '',
        startDate: '',
        expiryDate: '',
        privacy: false,
        islocked: false,
        serviceState: ''
      },
      contacts: [],
      nameServers: []
    }
  },
  methods: {
    ...mapActions('domainService', ['pushContacts', 'pushDomainData', 'pushNameServers', 'toggleLoadingDomain']),
    async getDomainDetails (domainRegId) {
      let contacts = []
      let nameServers = []
      const domainData = {
        domainName: '',
        autoRenew: '',
        isHidden: false,
        status: '',
        startDate: '',
        expiryDate: '',
        privacy: false,
        islocked: false,
        serviceState: '',
        term: ''
      }

      if (typeof domainRegId !== 'undefined') {
        try {
          const { data } = await this.$apollo.query({
            query: DOMAIN_GET_DETAILS,
            variables: {
              domainRegistrationId: domainRegId
            },
            fetchPolicy: 'network-only'
          })

          if (data.domainData !== null) {
            domainData.domainName = data.domainGet.domainName
            domainData.autoRenew = data.domainGet.autoRenew
            domainData.isHidden = data.domainGet.isHidden
            domainData.status = data.domainGet.status
            domainData.startDate = data.domainGet.startDate
            domainData.expiryDate = data.domainGet.expiryDate
            domainData.privacy = data.domainGet.expiry
            domainData.islocked = data.domainGet.islocked
            domainData.serviceState = data.domainGet.serviceState
            domainData.term = data.domainGet.term

            contacts = data.domainGet.contacts
            nameServers = data.domainGet.nameServers
          }
        } catch (err) {
        }
      }
      this.pushDomainData(domainData)
      this.pushContacts(contacts)
      this.pushNameServers(nameServers)
    },
    async saveDomainContact (domainRegistrationId, contactInfo) {
      try {
        const contacts = []

        if (contactInfo.countryCode.length > 0) {
          contactInfo.countryCode = contactInfo.countryCode.toUpperCase()
        }

        const parsedInfo = {
          title: contactInfo.title,
          firstName: contactInfo.firstName,
          lastName: contactInfo.lastName,
          companyName: contactInfo.companyName,
          companyPositionHeld: contactInfo.companyPositionHeld,
          addressLine1: contactInfo.addressLine1,
          addressLine2: contactInfo.addressLine2,
          city: contactInfo.city,
          province: contactInfo.province,
          state: contactInfo.state,
          countryCode: contactInfo.countryCode,
          emailAddress: contactInfo.emailAddress,
          telephoneNumber: contactInfo.telephoneNumber,
          faxNumber: contactInfo.faxNumber,
          postalCode: contactInfo.postalCode,
          contactType: contactInfo.contactType
        }
        contacts.push(parsedInfo)
        const { data } = await this.$apollo.mutate({
          mutation: MODIFY_DOMAIN_CONTACT,
          variables: {
            domainRegistrationId: domainRegistrationId,
            contacts: contacts
          }
        })
        this.getDomainDetails(domainRegistrationId)
        return true
      } catch (err) {
        return false
      }
    },
  }

}

export default domainOverviewMixin
